<template>
    <div class="modal bounceInUp animated" :class="classObject" :id="id" tabindex="-1" role="dialog" :aria-labelledby="`title-${id}`" aria-hidden="true" aria-modal="true">
        <div class="modal-dialog modal-dialog-centered" role="document" :class="`modal-${size}`">
            <div class="modal-content">
                <div class="modal-header">
                    <h2 class="modal-title" :id="'title-' + id">
                        <slot name="title"></slot>
                    </h2>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" role="button" autofocus>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body" v-if="displayContent">
                    <slot name="body"></slot>
                </div>
                <div class="modal-footer" v-if="showFooter">
                    <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                    <slot name="footer"></slot>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            id: {
                type: String,
                required: false,
                default: '',
            },
            size: {
                type: String,
                required: false,
                default: 'md',
            },
            className: {
                type: String,
                required: false,
                default: 'modal-primary',
            },
            showFooter:{
                type: Boolean,
                required: false,
                default: true,
            },
        },

        data(){
            return {
                displayContent: false,
            }
        },

        mounted() {
            $('#' + this.id).on('hidden.bs.modal', event => {
                this.$emit('close')
            })
            $('#' + this.id).on('shown.bs.modal', event => {
                if (!this.displayContent) {
                    this.displayContent = true;
                    this.$nextTick(() => {
                        this.$emit('trigger')
                    })
                }
            })
        },

        computed: {
            classObject() {
                return this.id + ' ' + this.className;
            }
        },


        computed: {
            classObject() {
                return this.id + ' ' + this.className;
            }
        }
    }
</script>